import CSVIcon from '@mui/icons-material/Assessment';
import PDFIcon from '@mui/icons-material/PictureAsPdf';
import LangEnum from '../../../../../lang/LangEnum';
import { OrderHeadersGroupByEnum } from '../../../products/orderProducts.types';
import {
  CsvTemplate,
  ExportFormat,
  ExportModel,
  ExportOrderForm,
  ExportTabConfig,
  ExportType,
  OptionKeyed,
  PageOrientation,
  SortBy,
} from '../ExportOrderModal.types';
export const PDF = ExportFormat.PDF;
export const CSV = ExportFormat.CSV;

export const EXPORT_ORDER_MODAL_HEIGHT = 580;

export const EXPORT_FORMAT_TABS: ExportTabConfig[] = [
  {
    value: PDF,
    labelKey: LangEnum.GLOBAL_DOCUMENT,
    exportType: '.pdf',
    Icon: PDFIcon,
    disableWhenOffline: true,
    ability: 'export-order-pdf',
  },
  {
    value: CSV,
    labelKey: LangEnum.GLOBAL_SPREADSHEET,
    exportType: '.csv',
    Icon: CSVIcon,
    ability: 'export-order-csv',
  },
];

export const DEFAULT_EXPORT_ORDER: ExportOrderForm = {
  format: PDF,
  exportType: ExportType.MULTIPLE_FILES,
  createSummary: true,
  pageOrientation: PageOrientation.PORTRAIT,
  exportModel: ExportModel.STANDARD,
  groupBy: OrderHeadersGroupByEnum.DEFAULT,
  sortBy: SortBy.LAST_ADDED,
  showPriceComposition: false,
  showMarkupAndSellout: false,
  showSizePriceVariation: false,
  showSellInPrice: true,
  csvTemplate: CsvTemplate.DEFAULT,
};

export const PDF_EXPORT_TYPE: OptionKeyed<ExportType>[] = [
  { value: ExportType.SINGLE_FILE, labelKey: LangEnum.ORDER_EXPORT_PDF_AS_SINGLE },
  { value: ExportType.MULTIPLE_FILES, labelKey: LangEnum.ORDER_EXPORT_PDF_AS_SEPARATE },
];

export const PDF_PAGE_ORIENTATION: OptionKeyed<PageOrientation>[] = [
  {
    value: PageOrientation.PORTRAIT,
    labelKey: LangEnum.ORDER_EXPORT_PDF_PAGE_ORIENTATION_PORTRAIT,
  },
  {
    value: PageOrientation.LANDSCAPE,
    labelKey: LangEnum.ORDER_EXPORT_PDF_PAGE_ORIENTATION_LANDSCAPE,
  },
];

export const PDF_EXPORT_MODELS: OptionKeyed<ExportModel>[] = [
  {
    value: ExportModel.COMPACT,
    labelKey: LangEnum.ORDER_PDF_EXPORT_TEMPLATE_COMPACT,
    description: LangEnum.ORDER_PDF_EXPORT_TEMPLATE_COMPACT_DESCRIPTION,
  },
  {
    value: ExportModel.STANDARD,
    labelKey: LangEnum.ORDER_PDF_EXPORT_TEMPLATE_STANDARD,
    description: LangEnum.ORDER_PDF_EXPORT_TEMPLATE_STANDARD_DESCRIPTION,
  },
  {
    value: ExportModel.DETAILED,
    labelKey: LangEnum.ORDER_PDF_EXPORT_TEMPLATE_DETAILED,
    description: LangEnum.ORDER_PDF_EXPORT_TEMPLATE_DETAILED_DESCRIPTION,
  },
  {
    value: ExportModel.ENLARGED,
    labelKey: LangEnum.ORDER_PDF_EXPORT_TEMPLATE_ENLARGED,
    description: LangEnum.ORDER_PDF_EXPORT_TEMPLATE_ENLARGED_DESCRIPTION,
  },
];

export const CSV_EXPORT_MODELS: OptionKeyed<CsvTemplate>[] = [
  { value: CsvTemplate.DEFAULT, labelKey: LangEnum.ORDER_EXPORT_ORDER_CSV_DEFAULT_CSV },
  { value: CsvTemplate.VERUP, labelKey: LangEnum.ORDER_EXPORT_ORDER_CSV_VERUP_ERP },
  { value: CsvTemplate.FILLED_MODEL, labelKey: LangEnum.ORDER_EXPORT_ORDER_CSV_FILLED_MODEL },
];

export const FIELD_LABELS = {
  exportType: LangEnum.ORDER_EXPORT_ORDER_PDF_AS_LABEL,
  createSummary: {
    summary: LangEnum.ORDER_EXPORT_ORDER_PDF_CREATE_ORDER_SUMMARY,
    applicable: LangEnum.ORDER_EXPORT_ORDER_PDF_SUMMARY_APPLICABLE,
    tooltipMessage: LangEnum.ORDER_EXPORT_ORDER_PDF_SUMMARY_APPLICABLE_TOOLTIP,
  },
  pageOrientation: LangEnum.ORDER_EXPORT_ORDER_PDF_PAGE_ORIENTATION_LABEL,
  exportModel: LangEnum.ORDER_EXPORT_ORDER_PDF_TEMPLATE_LABEL,
  groupBy: LangEnum.ORDER_PRODUCTS_GROUPY_BY_LABEL,
  sortBy: LangEnum.ORDER_PRODUCTS_SORT_BY_LABEL,
  showSellInPrice: LangEnum.ORDER_EXPORT_ORDER_PDF_SHOW_SELL_IN_PRICE,
  showPriceComposition: LangEnum.ORDER_EXPORT_ORDER_PDF_SHOW_PRICE_BREAKDOWN,
  showMarkupAndSellout: LangEnum.ORDER_EXPORT_ORDER_PDF_SHOW_MARKUP_SELLOUT_PRICE,
  showSizePriceVariation: LangEnum.ORDER_EXPORT_ORDER_PDF_SHOW_PRICE_VARIATION_BY_SIZE,
  csvTemplate: LangEnum.ORDER_EXPORT_ORDER_CSV_TEMPLATE,
  enableSellInValuesValuesToUnlockThisOption:
    LangEnum.ORDER_EXPORT_ORDER_ENABLE_SELL_IN_VALUES_TO_UNLOCK_THIS_OPTION,
};
